import React from 'react'
import Icon from '../res/icons'

const Badge = (props) => {
    const { icon, title, description } = props
    return (
        <div className="badge">
            <Icon name={icon} height={'42px'} fill="rgb(56, 137, 254)" />
            <p className="badge-title">{title}</p>
            <p className="badge-description">{description}</p>
        </div>
    );
}

export default Badge;